/**
 * Environment Detection Utilities
 * 
 * Browser-compatible environment detection that works in both Node.js and browser contexts.
 * Prevents "process is not defined" errors in client-side code.
 */

/**
 * Get NODE_ENV in a browser-compatible way
 */
export function getNodeEnv(): string {
  // Try Node.js environment first
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV || 'production';
  }
  
  // Fallback for browser environments - default to development in non-production builds
  // This will be replaced by Vite during build process
  return 'development';
}

/**
 * Environment detection flags
 */
export const isDevelopment = getNodeEnv() === 'development';
export const isProduction = getNodeEnv() === 'production';
export const isTest = getNodeEnv() === 'test';

/**
 * Get environment variable in a browser-compatible way
 */
export function getEnvVar(key: string, defaultValue?: string): string | undefined {
  // Try Node.js environment first
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key] || defaultValue;
  }
  
  // For browser environments, return default value
  // Vite environment variables would need to be handled differently
  return defaultValue;
}